export const VossPricingScheme = {
    UnitPricing: 0,
    TierPricing: 1
}

export const VossPricingSchemeText = {
    [VossPricingScheme.UnitPricing]: "Unit pricing",
    [VossPricingScheme.TierPricing]: "Tier pricing"
}